// Small helper to send events to Google Analytics 4 (gtag) and Meta Pixel (fbq).
// Each function safely no-ops if the scripts aren't loaded yet.

const gaEvent = (name, params = {}) => {
  if (typeof window === "undefined") return;
  if (typeof window.gtag === "function") {
    try { window.gtag("event", name, params); } catch (e) { /* noop */ }
  }
};

const fbEvent = (name, params = {}, standard = false) => {
  if (typeof window === "undefined") return;
  if (typeof window.fbq === "function") {
    try {
      if (standard) window.fbq("track", name, params);
      else window.fbq("trackCustom", name, params);
    } catch (e) { /* noop */ }
  }
};

// Public helpers — call these from onClick handlers etc.
export const trackWhatsApp = (source = "unknown") => {
  gaEvent("whatsapp_click", { source });
  fbEvent("Contact", { source, method: "whatsapp" }, true);
};

export const trackSocialClick = (network, source = "unknown") => {
  gaEvent("social_click", { network, source });
  fbEvent("SocialClick", { network, source });
};

export const trackSummerCTA = (variant = "whatsapp") => {
  gaEvent("summer_camp_cta", { variant });
  fbEvent("Lead", { content_name: "Summer Camp 2026", variant }, true);
};

export const trackPreEnrollmentClick = (source = "navbar") => {
  gaEvent("preenrollment_click", { source });
  fbEvent("InitiateCheckout", { source }, true);
};

export const trackFormSubmit = (extra = {}) => {
  gaEvent("form_submit", extra);
  fbEvent("Lead", { content_name: "Pre-registration form", ...extra }, true);
};
